import type {
  IInspectionsApi,
  TDeleteServiceProgrammesParams,
  TGetServiceProgrammesByIdParams,
  TGetServiceProgrammesParams,
  TUpdateServiceProgrammesByIdParams,
  TUpdateServiceProgrammesByIdRequestBody
} from '@/types/api-types'
import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import { expandedProperties } from '@/utils/constants'
import BaseApiRequest from '../BaseApiRequest'
import InspectionsApiUrl from './endpoints'
import type { TGetJobsParams } from '@/types/api-types/jobs'

class InspectionsApiRequest extends BaseApiRequest implements IInspectionsApi {
  async getInspection(params: TGetServiceProgrammesByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${InspectionsApiUrl.INSPECTIONS_BY_ID(params.id)}`
    return this.get(url, rest)
  }

  async updateInspection(
    params: TUpdateServiceProgrammesByIdParams,
    requestBody: TUpdateServiceProgrammesByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${InspectionsApiUrl.INSPECTIONS_BY_ID(id)}`
    return this.put(url, requestBody, { ...rest, ...expandedProperties })
  }

  async getInspectionsTasks(params: TGetJobsParams): TApiResponse {
    return this.get(InspectionsApiUrl.INSPECTIONS_TASKS(), params)
  }

  async getInspections(params: TGetServiceProgrammesParams): TApiResponse {
    return this.get(InspectionsApiUrl.INSPECTIONS(), params)
  }

  async deleteInspections(
    params?: TDeleteServiceProgrammesParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(InspectionsApiUrl.INSPECTIONS(), params)
  }

  async createServiceProgrammes(
    requestBody: TUpdateServiceProgrammesByIdRequestBody
  ): TApiResponse {
    return this.post(InspectionsApiUrl.INSPECTIONS(), requestBody, { ...expandedProperties })
  }
}

export default InspectionsApiRequest
